'use strict';

var angular = require('angular');
var Dashboard = require('../v2/components/dashboard/dashboard.jsx');
var dependencies = ['ui.router'];
module.exports = angular.module('AVRO.FaresOptimizer.HybridDashboard', dependencies).config(require('./config/HybridDashboardConfig')).component('dashboard', require('react2angular').react2angular(Dashboard["default"], [], ['App']));